const STORIES = [
  {
    tag: "深度 · 圈子内幕",
    cat: "成人吃瓜圈子内幕",
    title: "一张保密协议背后的江湖：成人吃瓜圈子的「嘴替」为什么越来越少了？",
    text: "我们把近半年那些没下文的人逐一回访，发现沉默往往不是终点，而是另一段成人吃瓜圈子内幕的开场。",
    meta: "专题 · 4200 字 · 8 图",
    img: "https://readdy.ai/api/search-image?query=dim%20study%20room%20with%20stacked%20documents%20and%20pen%20under%20single%20warm%20desk%20lamp%2C%20confidentiality%20and%20research%20mood%2C%20editorial%20photojournalism%2C%20film%20grain%2C%20warm%20amber%20and%20ink%20tones&width=720&height=480&seq=deep-a-x1&orientation=landscape",
  },
  {
    tag: "追踪 · 三观炸裂",
    cat: "三观炸裂",
    title: "从一句口误到全网失控，三观炸裂的 72 小时到底是谁在推波助澜？",
    text: "情绪被批量投喂的时代，我们拆解出一条被反复转发的链路，看看成人吃瓜行业爆料是如何在三观炸裂里长出二次生命。",
    meta: "复盘 · 3600 字 · 时间轴",
    img: "https://readdy.ai/api/search-image?query=large%20crowd%20of%20people%20looking%20down%20at%20bright%20phones%20at%20night%20event%2C%20arena%20lighting%20silhouettes%2C%20moody%20crowd%20photojournalism%2C%20warm%20and%20deep%20tones%2C%20cinematic%20grain&width=720&height=480&seq=deep-b-x1&orientation=landscape",
  },
  {
    tag: "人物 · 幕后",
    cat: "幕后闹剧",
    title: "幕后闹剧的另一面：那个总在收拾烂摊子的「隐形人」终于开口了",
    text: "大多数幕后闹剧都有替人圆场的角色。我们蹲了三场录制，试图还原成人吃瓜幕后闹剧里最不容易被看见的那一环。",
    meta: "特写 · 3100 字 · 独家",
    img: "https://readdy.ai/api/search-image?query=lone%20figure%20in%20empty%20auditorium%20walking%20toward%20stage%20lights%2C%20back%20view%2C%20documentary%20cinematic%2C%20warm%20spotlight%20and%20deep%20shadow%2C%20film%20grain%2C%20editorial%20tone&width=720&height=480&seq=deep-c-x1&orientation=landscape",
  },
];

export default function FeatureStories() {
  return (
    <section id="deep" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-700">LONG READ · 深度追踪</p>
            <h3 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              值得坐下来读完的长线
            </h3>
          </div>
          <a
            href="#ranking"
            className="hidden items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 md:flex"
          >
            更多长线复盘
            <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {STORIES.map((s, idx) => (
            <article
              key={idx}
              className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/60 bg-background-100"
            >
              <div className="relative overflow-hidden">
                <img
                  src={s.img}
                  alt={`成人吃瓜 ${s.cat} 深度文章`}
                  title={`成人吃瓜 ${s.cat}`}
                  className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-background-50/90 px-2 py-1 text-xs font-bold text-primary-700">
                  {s.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <p className="text-xs text-foreground-500">{s.cat}</p>
                <h4 className="mt-2 flex-1 font-heading text-lg font-bold leading-snug text-foreground-950">
                  <a href="#comment" className="hover:text-primary-700">
                    {s.title}
                  </a>
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.text}</p>
                <div className="mt-4 flex items-center justify-between border-t border-foreground-200/40 pt-3 text-xs text-foreground-500">
                  <span>{s.meta}</span>
                  <span className="flex items-center gap-1 text-primary-700">
                    深读
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}